export const SUPPORTED_LANGS = ['it', 'en', 'de', 'fr'];
export const DEFAULT_LANG = 'it';

// Translated page slugs per language
export const PAGE_SLUGS = {
  about: { it: 'chi-siamo', en: 'about-us', de: 'uber-uns', fr: 'a-propos' },
  project: { it: 'progetto', en: 'project', de: 'projekt', fr: 'projet' },
  portfolio: { it: 'portfolio', en: 'portfolio', de: 'portfolio', fr: 'portfolio' },
  'ai-video': { it: 'video-ai', en: 'ai-video', de: 'ai-video', fr: 'video-ai' },
};

// Translated section IDs for homepage sections
export const SECTION_IDS = {
  services: { it: 'servizi', en: 'services', de: 'leistungen', fr: 'services' },
  why_us: { it: 'perche-noi', en: 'why-us', de: 'warum-wir', fr: 'pourquoi-nous' },
  portfolio: { it: 'portfolio', en: 'portfolio', de: 'portfolio', fr: 'portfolio' },
  faq: { it: 'faq', en: 'faq', de: 'faq', fr: 'faq' },
  contact: { it: 'contatti', en: 'contact', de: 'kontakt', fr: 'contact' },
};

export function sectionId(lang, key) {
  const safeLang = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  return SECTION_IDS[key]?.[safeLang] || key;
}

// Reverse lookup: slug → page type
const SLUG_TO_PAGE = {};
Object.entries(PAGE_SLUGS).forEach(([page, slugs]) => {
  Object.values(slugs).forEach(slug => {
    SLUG_TO_PAGE[slug] = page;
  });
});

// Generate a localized path
export function localizedPath(lang, page, params = {}) {
  const safeLang = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  const base = `/${safeLang}`;
  switch (page) {
    case 'home':
      return base;
    case 'about':
      return `${base}/${PAGE_SLUGS.about[safeLang]}`;
    case 'project':
      return `${base}/${PAGE_SLUGS.project[safeLang]}/${params.slug}`;
    case 'portfolio':
      return `${base}/${PAGE_SLUGS.portfolio[safeLang]}`;
    default:
      return base;
  }
}

// Parse current pathname to extract { lang, page, params }
export function parsePathname(pathname) {
  const segments = pathname.split('/').filter(Boolean);
  const lang = SUPPORTED_LANGS.includes(segments[0]) ? segments[0] : null;
  if (!lang) return { lang: null, page: 'home', params: {} };
  if (segments.length === 1) return { lang, page: 'home', params: {} };

  const secondSlug = segments[1];
  const pageType = SLUG_TO_PAGE[secondSlug];

  if (pageType === 'about') {
    return { lang, page: 'about', params: {} };
  }
  if (pageType === 'portfolio') {
    return { lang, page: 'portfolio', params: {} };
  }
  if (pageType === 'ai-video') {
    return { lang, page: 'ai-video', params: {} };
  }
  if (pageType === 'project' && segments[2]) {
    return { lang, page: 'project', params: { slug: segments[2] } };
  }

  return { lang, page: 'home', params: {} };
}

// Get the equivalent path in a different language
export function switchLanguagePath(currentPath, newLang) {
  const { page, params } = parsePathname(currentPath);
  return localizedPath(newLang, page, params);
}

// Detect language from browser/localStorage
export function detectBrowserLang() {
  const stored = localStorage.getItem('i18nextLng');
  if (stored) {
    const shortLang = stored.substring(0, 2);
    if (SUPPORTED_LANGS.includes(shortLang)) return shortLang;
  }
  const browserLang = navigator.language?.substring(0, 2);
  if (SUPPORTED_LANGS.includes(browserLang)) return browserLang;
  return DEFAULT_LANG;
}
